<template>
  <div class="condition">
    <div class="header_select">
      <match-select v-model="conditionRule" />
      <div class="delete_btn" v-if="currentLevel > 1 && !hasSize" @click="$emit('remove', filterValue)">
        <span>
          <i class="el-icon-delete"></i>
        </span>
      </div>
    </div>
    <div class="content">
      <div class="condition_item" v-for="(rule, rIndex) of rules" :key="rule.ruleKey">
        <condition-item :questionList="questionList" :rule="rule" :show-remove="isItemRemove" @remove="removeCondition(rIndex)" />
      </div>
      <template v-if="ruleGroups.length > 0 && maxLevel > currentLevel">
        <div class="condition_item" v-for="(rg, rgIndex) of ruleGroups" :key="rg.groupKey">
          <condition
            :questionList="questionList"
            :group-index="rgIndex"
            :filter-value="rg"
            :max-level="maxLevel"
            :current-level="currentLevel + 1"
            @remove="removeConditionGroup(rgIndex)"
          />
        </div>
      </template>
    </div>
    <div class="condition_button">
      <el-button class="c_btn" type="text" icon="el-icon-plus" @click="addCondition">添加条件</el-button>
      <el-button class="c_btn" type="text" icon="el-icon-plus" v-if="maxLevel > currentLevel" @click="addConditionGroup"
        >添加条件组</el-button
      >
    </div>
  </div>
</template>

<script>
import MatchSelect from './ConditionMatchSelect'
import ConditionItem from './ConditionItem'
import { randomMixins } from './mixins'
import { createNoopCondition } from '@/condition/utils'

export default {
  name: 'Condition',
  mixins: [randomMixins],
  components: {
    MatchSelect,
    ConditionItem
  },
  inject: {
    params:{
      default: () => ({
        showStatFields: true,
        // group:''
      })
    }
  },
  props: {
    filterValue: {
      type: Object,
      default: () => ({})
    },
    maxLevel: {
      type: Number,
      default: Infinity
    },
    currentLevel: {
      type: Number,
      default: 1
    },
    questionList: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    ruleGroups() {
      return this.filterValue.ruleGroups || []
    },
    rules() {
      return this.filterValue.rules || []
    },
    // questionList() {
    //   return this.filterValue.questionList || []
    // },
    condition() {
      return this.filterValue.condition || []
    },
    isItemRemove() {
      const isOnlyItem = this.currentLevel === 1 && this.rules.length <= 1
      return !isOnlyItem
    },
    hasSize() {
      return this.rules.length + this.ruleGroups.length > 0
    },
    conditionRule: {
      get() {
        return `${this.filterValue.conditionRule ?? ''}`
      },
      set(val) {
        this.filterValue.conditionRule = Number.isNaN(+val) ? 1 : +val
      }
    }
  },
  methods: {
    getDefaultRuleData() {
      return {
        ruleKey: this.getRandomKey(),
        attributeId: -1,
        cascadeIdx: 0,
        classify: Object.keys(this.params).includes('getGroupId') ? 3 : 0,
        fieldName: '',
        params: null,
        type: '',
        condition:createNoopCondition()
      }
    },
    addCondition() {
      const ruleData = this.getDefaultRuleData()
      if (Array.isArray(this.filterValue.rules)) {
        this.filterValue.rules.push(ruleData)
      } else {
        this.$set(this.filterValue, 'rules', [ruleData])
      }
    },
    addConditionGroup() {
      if (this.maxLevel > this.currentLevel) {
        const groupData = {
          groupKey: this.getRandomKey(),
          conditionRule: 1,
          ruleGroups: [],
          rules: []
        }
        if (Array.isArray(this.filterValue.ruleGroups)) {
          this.filterValue.ruleGroups.push(groupData)
        } else {
          this.$set(this.filterValue, 'ruleGroups', [groupData])
        }
      }
    },
    removeCondition(index) {
      this.filterValue.rules.splice(index, 1)
    },
    removeConditionGroup(index) {
      this.filterValue.ruleGroups.splice(index, 1)
    }
  },
  mounted(){
    console.log('this.questionList',this.questionList)
  }
}
</script>

<style lang="scss" scoped>
.condition {
  .header_select {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }
  .delete_btn {
    margin-left: 8px;
    span {
      user-select: none;
      cursor: pointer;
    }
  }
  .content {
    margin-bottom: 16px;
  }
  .condition_item {
    margin-bottom: 8px;
    padding-left: 40px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .condition_button {
    padding-left: 40px;
    .c_btn {
      padding: 0;
    }
  }
}
</style>
